import { 
  DescriptionCell, 
  LabelCell,
  MainOuterCard, 
} from "../../../../../shared/styles";
import { CustomLabel, FlexContainer, Input } from "@mindmemobile/mm-shared-global";
import React, { FC } from "react"; 
import { ProductVariantEditableModel, ProductVariantEditablePriceModel } from "../../../../../shared/models";

type IProps = {
  editableVariant?: ProductVariantEditableModel | null;
  onUpdate: (variant: ProductVariantEditableModel) => void;
};

const VariantPriceSectionEditable: React.FC<IProps> = ({ editableVariant, onUpdate }) => {
  if (!editableVariant || !editableVariant.price) return null;

  function onChange(key: keyof ProductVariantEditablePriceModel, value: string) {
      if (!editableVariant?.price) return;

      const showForm =
          editableVariant.price.originalPriceByVariant ||
          editableVariant.price.originalPrice ||
          editableVariant.price.costByVariant;

      if (!showForm) return;

      const clone = new ProductVariantEditablePriceModel({ ...editableVariant.price });
      switch (key) {
          case 'price':
              clone.price = value;
              break;
          case 'originalPrice':
              clone.originalPrice = value;
              break;
          case 'cost':
              clone.cost = value;
              break;
      }
      onUpdate(
          new ProductVariantEditableModel({
              ...editableVariant,
              price: new ProductVariantEditablePriceModel(clone),
          }),
      );
  }
  function inputRow(label: string, value: string, key: keyof ProductVariantEditablePriceModel) {
      return (
          <FlexContainer spacing={20} alignItems="center" padding="0px 0px 20px">
              <LabelCell>
                  <CustomLabel>{label}</CustomLabel>
              </LabelCell>
              <DescriptionCell>
                  <Input
                      type="number"
                      error={editableVariant?.price?.hasError(key)}
                      value={value}
                      onChange={(e) => onChange(key, e.target.value)}
                  />
              </DescriptionCell>
          </FlexContainer>
      );
  }
  return (
      <>
          {editableVariant.price.priceByVariant ||
              editableVariant.price.originalPriceByVariant ||
              (editableVariant.price.costByVariant && (
                  <MainOuterCard margin="10px 0px" className="attribute-edit-panel">
                      <CustomLabel fontSize="20px" fontWeight="600" color="#2C3E50" margin="0px 0px 25px">
                          Pricing
                      </CustomLabel>
                      {editableVariant.price.priceByVariant &&
                          inputRow('Price', editableVariant.price.price, 'price')}
                      {editableVariant.price.originalPriceByVariant &&
                          inputRow('Original Price', editableVariant.price.originalPrice, 'originalPrice')}
                      {editableVariant.price.costByVariant && inputRow('Cost', editableVariant.price.cost, 'cost')}
                  </MainOuterCard>
              ))}
      </>
  );
};
export default VariantPriceSectionEditable;
